const defaultProperties = () => {
  if (typeof window === "undefined") return {}

  return {
    page_path: window.location.pathname,
    referrer: document?.referrer
  }
}

/**
 * Analytics Events are events that are meant to be tracked by Segment (see
 * services/analytics.rb). Segment is used by the data team to view internal analytics
 * data. This is different than `reportingEvent` which is meant to track data
 * that will be viewed by the user via reporting UI.
 *
 * == Example: tracking an internal event related to my feature
 *
 * Analytics.event( "viewed-my-feature", { page_title: "Settings"})
 *
 * @param {string} name - the name of the event
 * @param {object} properties - the properties of the event
 * @return {Promise} - a promise that resolves when the event is sent
 **/
function event(name, properties = {}) {
  return fetch("/ui/event", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      name,
      properties: { ...defaultProperties(), ...properties }
    })
  })
}

/**
 * Reporting Events are events that are meant to be viewed by the user via reporting UI.
 * This is different than `event` (Analytics.event) which is meant to be used for
 * internal tracking, data that the CK data team uses.
 *
 * Viewing the "Posts" tab on Creator Profile:
 *
 * Analytics.reportingEvent("view", {
 *   target_name: "Posts",
 *   target_id: 1234,
 *   target_type: "creator_profile_tab",
 *   source_name: "creator_profile",
 *   source_type: "newsletter",
 *   source_id: 1234,
 *   tags: ["my-tag", "my-react-component-name"]
 * })
 *
 * @param {string} name - the name of the event
 * @param {object} properties - the properties of the event
 * @return {Promise} - a promise that resolves when the event is sent
 **/
function reportingEvent(name, properties = {}) {
  const referrer =
    document.referrer == "" ? window.location.href : document.referrer

  const data = {
    name: name,
    properties: {
      referrer: referrer,
      source_path: window?.location?.pathname,
      user_agent: navigator?.userAgent,
      ...properties
    }
  }

  try {
    fetch("/ui/reporting_event", {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data)
    })
  } catch (e) {
    // Ignore
  }
}

export default { event, reportingEvent }
